import * as Scrivito from "scrivito"

export const RegistrationKpiWidget = Scrivito.provideWidgetClass(
  "RegistrationKpiWidget",
  {
    attributes: {
      content: "widgetlist"
    }
  }
)
